<template lang="pug">
.sraffPage
    h1.TitleU {{name}}
    .staffContainer(v-for='pos in data[year]')
        h1.chairTitle {{pos.title}}
        .staffListContainer
            .staffListContentBlock(v-for='item in pos.staff' data-aos="fade-up" data-aos-duration="2000")
                a.staffListName(v-if='item.href!=""' :href="item.href" target='_blank' style='color: #e8b279') {{item.name}}
                .staffListName(v-if='item.href==""') {{item.name}}
                .staffListTitle {{item.agency}}

</template>

<script>
export default {
    props: ['year'],
    data () {
        return {
            name: "ORGANIZERS",
            data: {
                2026: [
                    {title: "Workshop Chairs",
                    staff: [
                        {name: 'Chuang-Wen You',agency: 'National Tsing Hua University, Taiwan',href: "https://nthu-ubicomp-lab.github.io/#/members/cwyou/home"},
                        {name: 'Yi-Chao Chen',agency: 'Shanghai Jiao Tong University, China',href: "http://www.cs.sjtu.edu.cn/~yichao/pmwiki/pmwiki.php"},
                        {name: 'Liwei Chan',agency: 'National Yang Ming Chiao Tung University, Taiwan',href: "https://people.cs.nctu.edu.tw/~liweichan/"},
                        {name: 'Min-Chun Hu',agency: 'National Tsing Hua University, Taiwan',href: "http://mislab.cs.nthu.edu.tw"},
                        {name: 'Tse-Yu Pan',agency: 'National Taiwan University of Science and Technology, Taiwan',href: "https://sites.google.com/view/ntust-miislab"},
                        {name: 'Hao Pan',agency: 'Microsoft Research Asia, China',href: "https://haopan.netlify.app/"},
                        {name: 'Yongzhao Zhang',agency: 'University of Electronic Science and Technology of China, China',href: "https://www.scse.uestc.edu.cn/info/1081/15369.htm"},
                        {name: 'Yunqi Guo',agency: 'Chinese University of Hong Kong, China',href: "https://guoyunqi.com"},
                    ]},
                    {title: "Technical Program Committees",
                    staff: [
                        {name: 'Hung-Kuo Chu',agency: 'National Tsing Hua University, Taiwan',href: ""},
                        {name: 'Ping-Hsuan Han',agency: 'National Taipei University of Technology, Taiwan',href: ""},
                        {name: 'Xiaoyu Ji',agency: 'Zhejiang University, China',href: ""},
                        {name: 'Yijie Li',agency: 'National University of Singapore',href: ""},
                        {name: 'Feng Lyu',agency: 'Central South University, China',href: ""},
                        {name: 'Shih-Wei Sun',agency: 'Taipei National University of the Arts, Taiwan',href: ""},
                        {name: 'Hsin-Ruey Tsai',agency: 'National Chengchi University, Taiwan',href: ""},
                        {name: 'Taiting Lu',agency: 'Pennsylvania State University',href: ""},
                        {name: 'Chiu-Hsuan Wang',agency: 'National Taiwan University, Taiwan',href: ""},
                        {name: 'Sangki Yun',agency: 'Facebook',href: ""},
                    ]},
                    {title: "Web Chair",
                    staff: [
                        {name: 'Yan-Ming Chen',agency: 'National Tsing Hua University, Taiwan',href: ""}
                    ]}
                ],
                2025: [
                    {title: "Workshop Chairs",
                    staff: [
                        {name: 'Chuang-Wen You',agency: 'National Tsing Hua University, Taiwan',href: "https://nthu-ubicomp-lab.github.io/#/members/cwyou/home"},
                        {name: 'Yi-Chao Chen',agency: 'Shanghai Jiao Tong University, China',href: "http://www.cs.sjtu.edu.cn/~yichao/pmwiki/pmwiki.php"},
                        {name: 'Liwei Chan',agency: 'National Yang Ming Chiao Tung University, Taiwan',href: "https://people.cs.nctu.edu.tw/~liweichan/"},
                        {name: 'Min-Chun Hu',agency: 'National Tsing Hua University, Taiwan',href: "http://mislab.cs.nthu.edu.tw"},
                        {name: 'Wei Sun',agency: 'Samsung Research America',href: "https://scholar.google.com/citations?user=odTy4-YAAAAJ&hl=zh-CN"},
                        {name: 'Tse-Yu Pan',agency: 'National Taiwan University of Science and Technology, Taiwan',href: "https://sites.google.com/view/ntust-miislab"},
                        {name: 'Hao Pan',agency: 'Microsoft Research Asia, China',href: "https://haopan.netlify.app/"},
                        {name: 'Yongzhao Zhang',agency: 'University of Electronic Science and Technology of China, China',href: "https://www.scse.uestc.edu.cn/info/1081/15369.htm"},
                    ]},
                    {title: "Technical Program Committees",
                    staff: [
                        {name: 'Hung-Kuo Chu',agency: 'National Tsing Hua University, Taiwan',href: ""},
                        {name: 'Ping-Hsuan Han',agency: 'National Taipei University of Technology, Taiwan',href: ""},
                        {name: 'Xiaoyu Ji',agency: 'Zhejiang University, China',href: ""},
                        {name: 'Lik-Hang Lee',agency: 'Hong Kong Polytechnic University, China',href: ""},
                        {name: 'Dawei Liang',agency: 'University of Texas at Austin, USA',href: ""},
                        {name: 'Rong-Hao Liang',agency: 'TU Eindhoven, the Netherlands',href: ""},
                        {name: 'Yijie Li',agency: 'National University of Singapore',href: ""},
                        {name: 'Feng Lyu',agency: 'Central South University, China',href: ""},
                        {name: 'Takuji Narumi',agency: 'University of Tokyo, Japan',href: ""},
                        {name: 'Shih-Wei Sun',agency: 'Taipei National University of the Arts, Taiwan',href: ""},
                        {name: 'Hsin-Ruey Tsai',agency: 'National Chengchi University, Taiwan',href: ""},
                        {name: 'Taiting Lu',agency: 'Pennsylvania State University',href: ""},
                        {name: 'Chiu-Hsuan Wang',agency: 'National Taiwan University, Taiwan',href: ""},
                        {name: 'Sangki Yun',agency: 'Facebook',href: ""},
                        {name: 'Jinbei Zhang',agency: 'Sun Yat-sen University, China',href: ""},
                        {name: 'Yingying Zhao',agency: 'University of Strathclyde, UK',href: ""},
                    ]},
                    {title: "Web Chair",
                    staff: [
                        {name: 'Yan-Ming Chen',agency: 'National Tsing Hua University, Taiwan',href: ""}
                    ]}
                ],
                2024: [
                    {title: "Workshop Chairs",
                    staff: [
                        {name: 'Chuang-Wen You',agency: 'National Tsing Hua University, Taiwan',href: "https://nthu-ubicomp-lab.github.io/#/members/cwyou/home"},
                        {name: 'Yi-Chao Chen',agency: 'Shanghai Jiao Tong University, China',href: "http://www.cs.sjtu.edu.cn/~yichao/pmwiki/pmwiki.php"},
                        {name: 'Liwei Chan',agency: 'National Yang Ming Chiao Tung University, Taiwan',href: "https://people.cs.nctu.edu.tw/~liweichan/"},
                        {name: 'Min-Chun Hu',agency: 'National Tsing Hua University, Taiwan',href: "http://mislab.cs.nthu.edu.tw"},
                        {name: 'Wei Sun',agency: 'Samsung Research America',href: "https://scholar.google.com/citations?user=odTy4-YAAAAJ&hl=zh-CN"},
                        {name: 'Tse-Yu Pan',agency: 'National Taiwan University of Science and Technology, Taiwan',href: "https://sites.google.com/view/ntust-miislab"},
                        {name: 'Hao Pan',agency: 'Microsoft Research Asia, China',href: "https://haopan.netlify.app/"},
                        {name: 'Yongzhao Zhang',agency: 'University of Electronic Science and Technology of China, China',href: "https://www.scse.uestc.edu.cn/info/1081/15369.htm"},
                    ]},
                    {title: "Technical Program Committees",
                    staff: [
                        {name: 'Hung-Kuo Chu',agency: 'National Tsing Hua University, Taiwan',href: ""},
                        {name: 'Ping-Hsuan Han',agency: 'National Taipei University of Technology, Taiwan',href: ""},
                        {name: 'Xiaoyu Ji',agency: 'Zhejiang University, China',href: ""},
                        {name: 'Lik-Hang Lee',agency: 'Hong Kong Polytechnic University, China',href: ""},
                        {name: 'Dong Li',agency: 'University of Massachusetts Amherst, USA',href: ""},
                        {name: 'Dawei Liang',agency: 'University of Texas at Austin, USA',href: ""},
                        {name: 'Rong-Hao Liang',agency: 'TU Eindhoven, the Netherlands',href: ""},
                        {name: 'Feng Lyu',agency: 'Central South University, China',href: ""},
                        {name: 'Takuji Narumi',agency: 'University of Tokyo, Japan',href: ""},
                        {name: 'Shih-Wei Sun',agency: 'Taipei National University of the Arts, Taiwan',href: ""},
                        {name: 'Hsin-Ruey Tsai',agency: 'National Chengchi University, Taiwan',href: ""},
                        {name: 'Chiu-Hsuan Wang',agency: 'National Taiwan University, Taiwan',href: ""},
                        {name: 'Sangki Yun',agency: 'Facebook',href: ""},
                        {name: 'Jinbei Zhang',agency: 'Sun Yat-sen University, China',href: ""},
                        {name: 'Yingying Zhao',agency: 'University of Strathclyde, UK',href: ""},
                    ]},
                    {title: "Web Chair",
                    staff: [
                        {name: 'Yan-Ming Chen',agency: 'National Tsing Hua University, Taiwan',href: ""}
                    ]}
                ],
                2023: [
                    {title: "Workshop Chairs",
                    staff: [
                        {name: 'Chuang-Wen You',agency: 'National Tsing Hua University, Taiwan',href: "https://nthu-ubicomp-lab.github.io/#/members/cwyou/home"},
                        {name: 'Yi-Chao Chen',agency: 'Shanghai Jiao Tong University, China',href: "http://www.cs.sjtu.edu.cn/~yichao/pmwiki/pmwiki.php"},
                        {name: 'Liwei Chan',agency: 'National Yang Ming Chiao Tung University, Taiwan',href: "https://people.cs.nctu.edu.tw/~liweichan/"},
                        {name: 'Min-Chun Hu',agency: 'National Tsing Hua University, Taiwan',href: "http://mislab.cs.nthu.edu.tw"},
                        {name: 'Wei Sun',agency: 'Samsung Research America',href: "https://scholar.google.com/citations?user=odTy4-YAAAAJ&hl=zh-CN"},
                        {name: 'Yun-Jui Lee',agency: 'Corma New Media',href: "http://www.corma.com.tw"},
                    ]},
                    {title: "Technical Program Committees",
                    staff: [
                        {name: 'Hung-Kuo Chu',agency: 'National Tsing Hua University, Taiwan',href: ""},
                        {name: 'Hao Pan',agency: 'Microsoft Research Asia, China',href: ""},
                        {name: 'Ping-Hsuan Han',agency: 'National Taipei University of Technology, Taiwan',href: ""},
                        {name: 'Xiaoyu Ji',agency: 'Zhejiang University, China',href: ""},
                        {name: 'Lik-Hang Lee',agency: 'Hong Kong Polytechnic University, China',href: ""},
                        {name: 'Rong-Hao Liang',agency: 'TU Eindhoven, the Netherlands',href: ""},
                        {name: 'Feng Lyu',agency: 'Central South University, China',href: ""},
                        {name: 'Takuji Narumi',agency: 'University of Tokyo, Japan',href: ""},
                        {name: 'Tse-Yu Pan',agency: 'National Taiwan University of Science and Technology, Taiwan',href: ""},
                        {name: 'Qian Zhang',agency: 'Shanghai Jiao Tong University, China',href: ""},
                        {name: 'Shih-Wei Sun',agency: 'Taipei National University of the Arts, Taiwan',href: ""},
                        {name: 'Hsin-Ruey Tsai',agency: 'National Chengchi University, Taiwan',href: ""},
                        {name: 'Chiu-Hsuan Wang',agency: 'National Yang Ming Chiao Tung University, Taiwan',href: ""},
                        {name: 'Shigeo Yoshida',agency: 'University of Tokyo, Japan',href: ""},
                        {name: 'Sangki Yun',agency: 'Facebook',href: ""},
                        {name: 'Jinbei Zhang',agency: 'Sun Yat-sen University, China',href: ""},
                    ]},
                    {title: "Web Chair",
                    staff: [
                        {name: 'Yan-Ming Chen',agency: 'National Tsing Hua University, Taiwan',href: ""}
                    ]}
                ],
                2022: [
                    {title: "Workshop Chairs",
                    staff: [
                        {name: 'Chuang-Wen You',agency: 'National Tsing Hua University, Taiwan',href: "https://nthu-ubicomp-lab.github.io/#/members/cwyou/home"},
                        {name: 'Yi-Chao Chen',agency: 'Shanghai Jiao Tong University, China',href: "http://www.cs.sjtu.edu.cn/~yichao/pmwiki/pmwiki.php"},
                        {name: 'Hsin-Ruey Tsai',agency: 'National Chengchi University, Taiwan',href: "https://hsnuhrt.github.io"},
                        {name: 'Chu-Yin Chen',agency: 'Paris 8 University, French',href: "https://inrev.univ-paris8.fr/chu-yin-chen-pr"}
                    ]},
                    {title: "Technical Program Committees",
                    staff: [
                        {name: 'Liwei Chan',agency: 'National Yang Ming Chiao Tung University, Taiwan',href: ""},
                        {name: 'Hung-Kuo Chu',agency: 'National Tsing Hua University, Taiwan',href: ""},
                        {name: 'Hao Pan',agency: 'Microsoft Research Asia, China',href: ""},
                        {name: 'Ping-Hsuan Han',agency: 'National Taipei University of Technology, Taiwan',href: ""},
                        {name: 'Min-Chun Hu',agency: 'National Tsing Hua University, Taiwan',href: ""},
                        {name: 'Xiaoyu Ji',agency: 'Zhejiang University, China',href: ""},
                        {name: 'Lik-Hang Lee',agency: 'KAIST, South Korea',href: ""},
                        {name: 'Rong-Hao Liang',agency: 'TU Eindhoven, the Netherlands',href: ""},
                        {name: 'Feng Lyu',agency: 'Central South University, China',href: ""},
                        {name: 'Takuji Narumi',agency: 'University of Tokyo, Japan',href: ""},
                        {name: 'Shih-Wei Sun',agency: 'Taipei National University of the Arts, Taiwan',href: ""},
                        {name: 'Shigeo Yoshida',agency: 'University of Tokyo, Japan',href: ""},
                        {name: 'Sangki Yun',agency: 'Facebook',href: ""},
                        {name: 'Jinbei Zhang',agency: 'Sun Yat-sen University, China',href: ""}
                    ]},
                    {title: "Web Chair",
                    staff: [
                        {name: 'Chieh-Jui Ho',agency: 'National Tsing Hua University, Taiwan',href: ""}
                    ]}
                ],
                2021: [
                    {title: "Workshop Chairs",
                    staff: [
                        {name: 'Chuang-Wen You',agency: 'National Tsing Hua University, Taiwan',href: "https://nthu-ubicomp-lab.github.io/#/members/cwyou/home"},
                        {name: 'Yi-Chao Chen',agency: 'Shanghai Jiao Tong University, China',href: "http://www.cs.sjtu.edu.cn/~yichao/pmwiki/pmwiki.php"},
                        {name: 'Hsin-Ruey Tsai',agency: 'National Chengchi University, Taiwan',href: "https://hsnuhrt.github.io"},
                        {name: 'Bin Sheng',agency: 'Shanghai Jiao Tong University, China',href: "http://www.cs.sjtu.edu.cn/en/PeopleDetail.aspx?id=149"}
                    ]},
                    {title: "Technical Program Committees",
                    staff: [
                        {name: 'Andrea Bianchi',agency: 'KAIST, South Korea',href: ""},
                        {name: 'Liwei Chan',agency: 'National Yang Ming Chiao Tung University, Taiwan',href: ""},
                        {name: 'Lung-Pan Cheng',agency: 'National Taiwan University, Taiwan',href: ""},
                        {name: 'Yushi Cheng',agency: 'Tsinghua University, China',href: ""},
                        {name: 'Ping-Hsuan Han',agency: 'National Taipei University of Technology, Taiwan',href: ""},
                        {name: 'Min-Chun Hu',agency: 'National Tsing Hua University, Taiwan',href: ""},
                        {name: 'Xiaoyu Ji',agency: 'Zhejiang University, China',href: ""},
                        {name: 'Lik-Hang Lee',agency: 'KAIST, South Korea',href: ""},
                        {name: 'Rong-Hao Liang',agency: 'TU Eindhoven, the Netherlands',href: ""},
                        {name: 'Feng Lyu',agency: 'Central South University, China',href: ""},
                        {name: 'Koya Narumi',agency: 'University of Tokyo, Japan',href: ""},
                        {name: 'Takuji Narumi',agency: 'University of Tokyo, Japan',href: ""},
                        {name: 'Jun Nishida',agency: 'University of Chicago, USA',href: ""},
                        {name: 'Shih-Wei Sun',agency: 'Taipei National University of the Arts, Taiwan',href: ""},
                        {name: 'Lu Tang',agency: 'Xiamen University, China',href: ""},
                        {name: 'Guangtao Xue',agency: 'Shanghai Jiao Tong University, China',href: ""},
                        {name: 'Shigeo Yoshida',agency: 'University of Tokyo, Japan',href: ""},
                        {name: 'Sangki Yun',agency: 'Facebook',href: ""},
                        {name: 'Jinbei Zhang',agency: 'Sun Yat-sen University, China',href: ""},
                        {name: 'Xinlei Zhang',agency: 'University of Tokyo, Japan',href: ""}
                    ]},
                    {title: "Web Chair",
                    staff: [
                        {name: 'Chieh-Jui Ho',agency: 'National Tsing Hua University, Taiwan',href: ""}
                    ]}
                ]
            }
        }
    },
    methods: {

    }
}
</script>

<style lang="sass" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap')

.TitleU
    text-align: center


.staffContainer
    max-width: 1080px
    margin: auto


@media (max-width: 960px)
    .staffListContentBlock
        width: 100%
    .staffListContainer
        width: 100%
    .staffContainer
        flex-flow: wrap
    .staffListContentBlock
        padding-top: 15px
        margin-top: 0 !important
    .chairTitle
        text-align: center

.staffListContentBlock
    margin: 30px
    width: 270px
    margin-left: 40px

.staffListContainer
    display: flex
    flex-flow: wrap
    margin-bottom: 50px

.staffListImage
    width: 175px
    height: 175px
    border-radius: 8px
    margin: 25%
    background-position: center
.staffListName
    font-size: 19px
    font-weight: bold
    width: 100%
    font-family: 'Roboto', sans-serif
    font-weight: bold
    padding: 10px 0
.staffListTitle
    font-size: 19px
    width: 100%
    font-family: 'Roboto', sans-serif
.chairTitle
    width: 100%
</style>



// WEBPACK FOOTER //
// src/components/mainPage/Staff.vue